module.exports = __webpack_public_path__ + "static/media/ic-member.e5e308fe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/ic-member.svg
// module id = 782
// module chunks = 0